import { Button } from '@mui/material'
import React from 'react'

import arrowIcon from '../../media/arrow_icon.svg'

const SeeMoreBtn = ({ label }) => {
	return (
		<Button
			color="secondary"
			sx={{
				p: (theme) => theme.spacing(0, 2.5, 0, 0),
				m: 0,
				borderRadius: 0,
				textTransform: 'none',
				fontSize: 16,
				fontWeight: 700,
				mt: 2,
				mb: 3,
				background: `url(${arrowIcon}) no-repeat right .7rem`,
				'&:hover': {
					bgcolor: 'text.white',
					borderBottom: (theme) => `1px solid ${theme.palette.secondary.main}`,
				},
			}}
		>
			{label || 'Savoir plus'}
		</Button>
	)
}

export default SeeMoreBtn
